import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import useUpdateMode from '@hooks/useUpdateMode'
import { saveAnswer } from '@utils/onboardingStorage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'

const QUESTION_KEY = 'v1_clutter_impact'

const OPTIONS = [
  {
    value: 'Constant low-level stress',
    translationKey: 'pages.onboarding.clutterImpact.options.stress',
  },
  {
    value: 'I avoid certain rooms',
    translationKey: 'pages.onboarding.clutterImpact.options.avoidRooms',
  },
  {
    value: 'It affects my sleep',
    translationKey: 'pages.onboarding.clutterImpact.options.sleep',
  },
  {
    value: 'I feel embarrassed having guests',
    translationKey: 'pages.onboarding.clutterImpact.options.embarrassed',
  },
  {
    value: 'It drains my energy',
    translationKey: 'pages.onboarding.clutterImpact.options.energy',
  },
]

export default function ClutterImpactPage() {
  const submit = useSubmit()
  const { t } = useTranslation()
  const { isUpdate, postToReactNative } = useUpdateMode()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const formData = new FormData(event.currentTarget)
    const value = formData.get('answer') as string

    if (!value) return

    const answer = {
      question_key: QUESTION_KEY,
      question: 'How does clutter affect your daily life?',
      answer_key: value,
      answer: value,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(event.currentTarget)
    }
  }

  const buttons = OPTIONS.map((option) => ({
    text: t(option.translationKey),
    value: option.value,
  }))

  return (
    <QuestionPage
      heading={t('pages.onboarding.clutterImpact.heading')}
      buttons={buttons}
      onSubmit={handleSubmit}
      headingSize="text-3xl text-center whitespace-pre-line"
      buttonTextSize="text-xl"
      buttonBgColor="bg-white"
    />
  )
}
